import React, { ReactElement, memo } from 'react'
import NonFlexingContainer from '@sport1/news-styleguide/NonFlexingContainer'

const ExternalWebContentSkeleton = (): ReactElement => {
    return (
        <NonFlexingContainer
            testID="external-web-content-skeleton"
            backgroundColor="pearl"
            marginBottom={['spacing-7', 'spacing-7', 'spacing-7', 'spacing-9']}
        >
            <div
                style={{
                    height: 211,
                    border: '1px solid black',
                }}
            />
        </NonFlexingContainer>
    )
}

export default memo(ExternalWebContentSkeleton)
